import React from 'react';

import {
  NumericMetricWidget,
  NumericMetricWidgetFormType,
} from '@portals/device-widgets';

import { WidgetProps } from '../device-widgets.types';

export function NumericMetricWidgetWrapper({
  widget,
  deviceState,

  isDeviceOffline,
  lastUpdateTimestamp,
}: WidgetProps<NumericMetricWidgetFormType>) {
  const fields = widget?.config?.fields;

  const {
    name,
    telemetry,
    with_measurement_unit,
    measurement_unit,
    telemetry_as_title,
    title_telemetry,
    number_format,
    num_of_decimals,
  } = fields ?? {};

  const telemetryValue = deviceState?.[telemetry] as number;
  const title = telemetry_as_title
    ? deviceState?.[title_telemetry] || 'N/A'
    : name;

  return (
    <NumericMetricWidget
      title={title}
      value={telemetryValue}
      unit={with_measurement_unit ? measurement_unit : null}
      numberFormat={number_format}
      numberOfDecimals={num_of_decimals}
      isDeviceOffline={isDeviceOffline}
      lastUpdateTimestamp={lastUpdateTimestamp}
    />
  );
}
